/**
 * Initializing Swiper Slider
 */
import Swiper from 'swiper/bundle';

var swiper = new Swiper(".slider-secondary .slider__clip", {
	speed: 400,
	pagination: {
		el: ".slider-secondary .slider__pagination",
		type: "fraction",
		formatFractionCurrent: function (number) {
		return ('0' + number).slice(-2);
		},
		formatFractionTotal: function (number) {
			return ('0' + number).slice(-2);
		},
	},
	navigation: {
		nextEl: ".slider-secondary .slider__next",
		prevEl: ".slider-secondary .slider__prev",
	},
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	loop: true,
	slidesPerView: 1,
});